export default __webpack_public_path__ + "static/media/ubereats.3e3fb28f.svg";